export const tw = {
  title: '第七史詩團戰匯報工具',
  darkMode: '深色模式',
  tower: '防守方名字(可選)...',
  t1: 'P1',
  t2: 'P2',
  report: '生成報告',
  firstHero: '你的一速英雄',
  speed: '速度',
  speedimprint: '速度陣',
  hp: '生命',
  cr: '% 速攻值',
  outspeed: '被對方超車?',
  repostMySpeedOne: '我方一速',
  repostSpeed: '行動條',
  outspeedDesc: '對面比我快?',
  extraInfos: '備註...',
  setCounter: '反擊套',
  setImmunity: '免疫套',
  setLifesteal: '吸血套',
  setInjury: '傷口套',
  heroesSaved: '你輸入的英雄以及速度會保存在本地',
  copyText: '複製到剪貼簿',
  copyTextSL: '複製到剪貼簿(單行)',
  copyTextImage: '複製為圖片',
  reset: '數據重置',
  copyToast: '已複製到剪貼簿!',
  resetToast: '數據已重置!',
  enemiesFirstHero: '對方一速',
  enemiesSecondHero: '對方二速',
  enemiesThirdHero: '對方尾速',
  enemiesFirstArtifact: '神器',
  enemiesSecondArtifact: '神器',
  enemiesThirdArtifact: '神器',
  formatHpK: '萬',
  showRawSpeedData: '顯示原始速度數據',
  crBonus: '% 速攻值變化(退條)',
  crBonusDesc: '例子 : 如果你一速英雄被巴薩爾退條，此處填寫30',
  crPush: '% 速攻值變化(拉條)',
  crPushDesc: '例子 : 如果你一速英雄被蘿季超車拉條，此處填寫25',
  crPushAlly: '% 速攻值變化(隊友拉條)',
  crPushAllyDesc: '例子 : 如果你的大將法濟斯被敵人攻擊，此處填寫15',
  updateTitle: '1月27日, 更新 :',
  updateContent: '新增角色: 「雨脩、珠妮、達拉士、莉珈、達黎兒、斯坦、平衡的尤貝烏斯」; 新增神器: 「焚滅之球」',
};
